import { inject, Injectable } from '@angular/core';
import { TenantKey } from '@app/core/enums/tenant-key.enum';
import { GuardianshipStartNavigationService } from '@app/guardianship/features/start/services/guardianship-start-navigation.service';
import { TenantFacadeService } from '@shared/features/tenant/shared/services/tenant-facade.service';
import { ProbateStartNavigationService } from '@app/probate/features/start/services/probate-start-navigation.service';
import { MinorPreviewNavigationService } from '@app/minor-estates/features/start/features/preview/shared/services/minor-preview-navigation.service';
import { TrustStartNavigationService } from '@app/trust/features/start/services/trust-start-navigation.service';

@Injectable()
export class RegisterRedirectionsService {
  private readonly _tenantFacadeService = inject(TenantFacadeService);
  private readonly _guardianshipStartNavigation = inject(
    GuardianshipStartNavigationService,
  );
  private readonly _probateStartNavigationService = inject(
    ProbateStartNavigationService,
  );

  private readonly _minorPreviewNavigation = inject(
    MinorPreviewNavigationService,
  );
  private readonly _trustStartNavigation = inject(TrustStartNavigationService);

  private readonly _navigationMap = {
    [TenantKey.GUARDIANSHIP]: () =>
      this._guardianshipStartNavigation.goToCourtOrder(),
    [TenantKey.PROBATE]: () =>
      this._probateStartNavigationService.goToWillEstate(),
    [TenantKey.MINOR]: () =>
      this._minorPreviewNavigation.goToRelationshipConfirmation(),
    [TenantKey.TRUST]: () => this._trustStartNavigation.goToTrustInfo(),
  };

  public redirectBasedInTenant() {
    const tenant = this._tenantFacadeService.currentTenantKey();

    if (!tenant) return;

    const isValidTenant = Object.values(TenantKey).includes(tenant);

    if (!isValidTenant) return;

    this._navigationMap[tenant]?.();
  }
}
